import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { InlineNotice, PickerDialog } from '@wit-support/ui';
import { AddPickedButton, usePicked } from './picker-parts.js';
import { MediaFilters, MediaSourceGrid, MediaSourceTabs, useMediaFilters, } from './media-sources.js';
import { UploadDropArea, UploadLeaveGuard, useUploads } from './uploads.js';
/** Загруженный файл медиатеки → элемент выбора (тот же вид, что у источников). */
export function sourceItemOfAsset(a) {
    return {
        source: 'uploaded',
        assetId: a.assetId,
        origin: null,
        kind: a.kind,
        name: a.name,
        previewUrl: a.previewUrl,
        width: a.width,
        height: a.height,
        durationSec: a.durationSec,
        inAccounts: a.byAccount.map((m) => ({
            platformAccountId: m.platformAccountId,
            state: m.state,
        })),
        creative: null,
        usage: null,
        createdAt: a.createdAt,
    };
}
/**
 * ОДИН выбор картинок и видео для пачки (спека v3 §2): вкладки «Загруженные»
 * / «Уже в рекламе» / «Библиотека кабинета», поиск, тип, превью, подгрузка
 * при прокрутке. Новый файл перетаскивается прямо сюда (вкладка
 * «Загруженные») и сразу отмечается. Файл, которого нет в кабинете запуска,
 * auto-ads перенесёт туда сам — ручных шагов нет.
 */
export function MediaPickerDialog({ open, onOpenChange, accounts, preferredAccountId, accountNames, canUpload, health, onPick, }) {
    const [source, setSource] = useState('uploaded');
    const picked = usePicked((i) => i.assetId);
    const filters = useMediaFilters(preferredAccountId ?? accounts[0]?.id ?? null);
    const { add } = picked;
    // загруженный здесь файл сразу отмечен
    const uploads = useUploads(useCallback((asset) => add(sourceItemOfAsset(asset)), [add]));
    return (_jsx(PickerDialog, { open: open, onOpenChange: onOpenChange, busy: uploads.busy, onReset: () => {
            picked.reset();
            uploads.clearFinished();
        }, size: "page", title: "\u041A\u0430\u0440\u0442\u0438\u043D\u043A\u0438 \u0438 \u0432\u0438\u0434\u0435\u043E", description: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0444\u0430\u0439\u043B\u044B \u0434\u043B\u044F \u043A\u0440\u0435\u0430\u0442\u0438\u0432\u043E\u0432. \u0415\u0441\u043B\u0438 \u0444\u0430\u0439\u043B\u0430 \u043D\u0435\u0442 \u0432 \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0435 \u0437\u0430\u043F\u0443\u0441\u043A\u0430, \u043E\u043D \u043F\u0435\u0440\u0435\u043D\u0435\u0441\u0451\u0442\u0441\u044F \u0442\u0443\u0434\u0430 \u0441\u0430\u043C.", footer: _jsx(AddPickedButton, { count: picked.picked.length, busy: uploads.busy, onClick: () => {
                onPick(picked.picked);
                picked.reset();
                uploads.clearFinished();
                onOpenChange(false);
            } }), children: _jsxs("div", { className: "flex flex-col gap-3", children: [_jsx(UploadLeaveGuard, { busy: uploads.busy }), _jsx(MediaSourceTabs, { value: source, onChange: setSource }), source === 'uploaded' ? (canUpload ? (_jsx(UploadDropArea, { uploads: uploads, health: health })) : (_jsx(InlineNotice, { variant: "muted", as: "div", children: "\u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0442\u044C \u0444\u0430\u0439\u043B\u044B \u043C\u043E\u0436\u0435\u0442 \u0441\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440 \u0438\u043B\u0438 \u0432\u043B\u0430\u0434\u0435\u043B\u0435\u0446." }))) : null, _jsx(MediaFilters, { filters: filters, accounts: accounts, withAccount: source !== 'uploaded' }), _jsx(MediaSourceGrid, { source: source, filters: filters.value, accountNames: accountNames, isPicked: picked.has, onToggle: picked.toggle, enabled: open, forAccountId: preferredAccountId })] }) }));
}
//# sourceMappingURL=media-picker-dialog.js.map